import { render } from "./AchievementsView.vue?vue&type=template&id=9290edf0"
import script from "./AchievementsView.vue?vue&type=script&lang=js"
export * from "./AchievementsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__